import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface AdvancedSearchDialogConfig {
  term: string;
}

@Component({
  selector: 'app-advanced-search-dialog',
  template: ` <app-advanced-search
    (itemClick)="dialogRef.close($event)"
    [style.min-width]="'70vw'"
    [style.padding.px]="20"
    [term]="data.term"
  ></app-advanced-search>`,
  styles: [``],
})
export class AdvancedSearchDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: AdvancedSearchDialogConfig,
    public dialogRef: MatDialogRef<AdvancedSearchDialogComponent>
  ) {}

  ngOnInit(): void {}
}
